import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { CasSecondaryButton } from 'src/compass/shared/components/CasButton/CasSecondaryButton';
import Iconify from 'src/components/iconify';

import { INSERT_DATA_TABLE_COMMAND } from './InsertDataTableCommand';

/**
 * "Insert Data" button living in the editor's sticky footer (left side, opposite the mic).
 * Inserts the SCE data table at the current cursor. Rendered only when the editor has a
 * dataTableConfig (so CasTableDataPlugin — which registers INSERT_DATA_TABLE_COMMAND — is mounted).
 */
export default function InsertDataTableButton() {
  const [editor] = useLexicalComposerContext();

  return (
    <CasSecondaryButton
      type="button"
      size="small"
      startIcon={<Iconify icon="mingcute:add-line" />}
      // Prevent the click from stealing the editor selection so the table lands at the cursor.
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => editor.dispatchCommand(INSERT_DATA_TABLE_COMMAND, undefined)}
    >
      Insert Data
    </CasSecondaryButton>
  );
}
